angular.module('files')
    .component('fileUploadButton', {
        bindings: {
            file: '<',
            url: '@',
            onChanged: "&",
        },
        template: `
            <div class="btn-group" uib-dropdown uib-keyboard-nav auto-dropdown dropdown-append-to-body is-open="dropdown.isOpen">
                <button type="button" class="btn btn-xs btn-default" ng-class="{ 'btn-default': $ctrl.file, 'btn-danger': !$ctrl.file }" uib-dropdown-toggle>
                    <i class="fa fa-fw fa-paperclip"></i>&nbsp;
                    <span ng-if="$ctrl.file != null">Załącznik</span>&nbsp;
                    <span ng-if="$ctrl.file == null">Brak załącznika</span>&nbsp;
                    <i class="fa fa-caret-down"></i>
                </button>
                <ul class="text-left dropdown-menu-right" uib-dropdown-menu>
                    <li ng-if="$ctrl.file == null">
                        <a href ng-click="$ctrl.upload()">
                            <i class="fa fa-fw fa-paperclip"></i><span translate="upload.help.add-from-device"></span>
                        </a>
                    </li>
                    <li ng-if="$ctrl.file != null && !$ctrl.file.notPersisted">
                        <a ng-href="{{$ctrl.url}}" target="_blank">
                            <i class="fa fa-fw fa-download"></i>{{ 'file.download' | translate }}
                        </a>
                    </li>
                    <li role="separator" class="divider" ng-if="$ctrl.file"></li>
                    <li ng-if="$ctrl.file">
                        <a href ng-click="$ctrl.delete()">
                            <i class="fa fa-fw fa-trash"></i>Usuń załącznik
                        </a>
                    </li>
                </ul>
            </div>
        `,
        controller($scope, $state, Project, modals, FilesSimpleUploadService) {
            this.upload = (file) => {
                FilesSimpleUploadService.open({})
                    .then(result => {
                        if (!angular.isArray(result)) {
                            toastr.error("Nie udało się przesłać pliku")
                            return
                        }
                        this.file = {
                            // file: result[0],
                            type: result[0].type,
                            uuid: result[0].uuid,
                            notPersisted: true
                        }
                        this.onChanged({
                            value: this.file
                        })
                    })
            }
            this.delete = (file) => {
                this.file = null
                this.onChanged({
                    value: null
                })
            }
        }
    })
